export const DIRECT_DAMAGE = 'directdamage';
export const FURY = 'fury';
export const WEAKNESS = 'weakness';
export const PRECISION = 'precision';
export const FATIGUE = 'fatigue';
export const CRUELTY = 'cruelty';
export const EXHAUST = 'exhaust';
export const ARMOR_BREAK = 'armorbreak';
export const ARMOR_UP = 'armorup';
export const PHYSICAL_RESIST = 'physicalresist';
export const UNSTOPPABLE = 'unstoppable';
export const POISON = 'poison';
export const POISON_IMMUNITY = 'poisonimmunity';
export const CAUTERIZE = 'cauterize';
export const BLEED = 'bleed';
export const BLEED_IMMUNITY = 'bleedimmunity';
export const SHOCK = 'shock';
export const INCINERATE = 'incinerate';
export const POWER_STEAL = 'powersteal';
export const POWER_DRAIN = 'powerdrain';
export const POWER_BURN = 'powerburn';
export const POWER_LOCK = 'powerlock';
export const REGENERATION = 'regeneration';
export const DEGENERATION = 'degeneration';
export const HEALTH_STEAL = 'healthsteal';
export const HEAL_BLOCK = 'healblock';
export const ENERGY_RESIST = 'energyresist';
export const ENERGY_ABSORB = 'energyabsorb';
export const STUN = 'stun';
export const STAGGER = 'stagger';
export const NULLIFY = 'nullify';
export const LIMBO = 'limbo';
export const EVADE = 'evade';



// WEBPACK FOOTER //
// ./src/data/ids/abilities.js